import { Navigate } from "react-router-dom";

export const RedirectionPage = () => {
  const workflowStagePath = localStorage.getItem("workflowStagePath");
  if (workflowStagePath === null) {
    return <Navigate to="/" />;
  }
  return <Navigate to={workflowStagePath} />;
};
